import * as yup from 'yup';
import { NAME_COMPANY_REGEX, NAME_REGEX } from '@/modules/common/utils/regex.ts';

export const validateShareholderSchema = (required = false, shareholderName = '') => {
  const schema = yup.array().of(
    yup.object({
      same_as_index: yup.string().trim(),
      type: yup
        .string()
        .trim()
        .when(['same_as_index'], ([same_as_index], schema) => {
          if (!same_as_index) {
            return schema.required('This field is required');
          }
          return schema;
        }),
      first_name: yup
        .string()
        .trim()
        .when(['type', 'same_as_index'], ([type, same_as_index], schema) => {
          if (type === 'individual' && !same_as_index) {
            return schema
              .matches(
                NAME_REGEX,
                'Invalid format, only allowed: letters, apostrophes, spaces, hyphens',
              )
              .required('This field is required');
          }
          return schema;
        }),
      last_name: yup
        .string()
        .trim()
        .when(['type', 'same_as_index'], ([type, same_as_index], schema) => {
          if (type === 'individual' && !same_as_index) {
            return schema
              .matches(
                NAME_REGEX,
                'Invalid format, only allowed: letters, apostrophes, spaces, hyphens',
              )
              .required('This field is required');
          }
          return schema;
        }),
      company_name: yup
        .string()
        .when(['type', 'same_as_index'], ([type, same_as_index], schema) => {
          if (type === 'company' && !same_as_index) {
            return schema
              .trim()
              .matches(
                NAME_COMPANY_REGEX,
                'Invalid format, only allowed: letters, numbers, spaces, apostrophes, hyphens, slashes and #',
              )
              .required('This field is required');
          }
          return schema;
        }),
    }),
  );

  if (required) {
    return schema
      .nonNullable(`At least 1 ${shareholderName} is required`)
      .min(1, `At least 1 ${shareholderName} is required`);
  }

  return schema.nullable();
};
